import React, { useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { METIERS } from "@/constants/labels";

const FAMILIES = Object.keys(METIERS);
const short = (k) => k.replace(/^[\w]+ — /, "");
const code = (k) => k.split(" — ")[0];

export const Metiers = () => {
  const [active, setActive] = useState(null);
  const specs = active ? Object.keys(METIERS[active] || {}) : [];
  return (
    <section className="relative bg-[#FAFAF7]" data-testid="metiers-section">
      <div className="max-w-4xl mx-auto px-5 md:px-8 py-20 md:py-32 text-center">
        <h2 className="font-display text-2xl sm:text-3xl lg:text-5xl font-semibold tracking-[-0.02em] text-[#0F2338] leading-[1.05]">
          Tous les corps de métier du bâtiment.
        </h2>
        <p className="font-body-l mt-4 text-base text-[#475569] leading-relaxed max-w-2xl mx-auto">
          Une nomenclature unique, du gros œuvre à la coordination. Touchez une famille pour voir ses spécialités.
        </p>
        <div className="mt-10 flex flex-wrap justify-center gap-2.5" role="tablist">
          {FAMILIES.map((f) => (
            <button key={f} type="button" role="tab" aria-selected={active === f} onClick={() => setActive(active === f ? null : f)}
              className={`px-4 py-2.5 rounded-full text-sm font-semibold border transition-colors duration-300 font-body-l ${active === f ? "bg-[#1B3A5C] text-white border-[#1B3A5C]" : "bg-white text-[#0F2338] border-[#1B3A5C]/15 hover:border-[#1B3A5C]"}`}
              data-testid={`metier-tab-${code(f)}`}>
              {short(f)}
            </button>
          ))}
        </div>
        <AnimatePresence mode="wait">
          {active && (
            <motion.div key={active} initial={{ opacity: 0, y: 10 }} animate={{ opacity: 1, y: 0 }} exit={{ opacity: 0, y: -8 }} transition={{ duration: 0.3 }}
              className="mt-8 flex flex-wrap justify-center gap-2" data-testid="metier-specs">
              {specs.map((s) => (
                <span key={s} className="px-3 py-1.5 rounded-full bg-[#FFF4EA] border border-[#E8710A]/30 text-xs md:text-sm text-[#0F2338] font-body-l">{s}</span>
              ))}
            </motion.div>
          )}
        </AnimatePresence>
      </div>
    </section>
  );
};
